import Swiper from 'swiper/swiper-bundle.min';

export default () => {
  const cardSlider = new Swiper('.js-card-slider', {
    loop: true,
    slidesPerView: 1,
    allowTouchMove: false,
    preloadImages: false,
    lazy: true,
    navigation: {
      nextEl: '.rc-card__slide-button--next',
      prevEl: '.rc-card__slide-button--prev'
    }
  })
}



// WEBPACK FOOTER //
// ./resources/assets/js/blocks/residential-complex/card-slider.js